import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './Installation.module.css'; // Создадим этот файл стилей позже
import Banner from '../sections/Banner/Banner';
import Cards from '../../../components/CardsUI/Cards/Cards';
import Table from '../sections/Table/Table';
import ServicesDescription from '../../../components/EntToEndUI/ServicesDescription/ServicesDescription';
import { PhoneLineIcon, FileIcon, PlaneIcon, CraneIcon } from '../../../components/Other/Icons/Icons';
import RequestForm from '../../../components/EntToEndUI/RequestForm/RequestForm';
import InstallationPriceTable from '../../../components/Tables/InstallationPriceTable/InstallationPriceTable';
import InfoGraphickBlock from '../sections/InfoGraphickBlock/InfoGraphickBlock';
import PageTitle from '../../../components/Other/PageTitle/PageTitle';

const Installation = () => {
  const serviceType = 'installation'
  const { t } = useTranslation();
  const cards = [
    {
      title: 'ПОДГОТОВИТЕЛЬНЫЕ, ЗЕМЛЯНЫЕ РАБОТЫ',
      image: '/images/cards/installation/1.png',
    },
    {
      title: 'МОНОЛИТНЫЕ, БЕТОННЫЕ, ЖЕЛЕЗОБЕТОННЫЕ РАБОТЫ',
      image: '/images/cards/installation/2.png',
    },
    {
      title: 'МОНТАЖ МЕТАЛЛИЧЕСКИХ КОНСТРУКЦИЙ',
      image: '/images/cards/installation/3.png',
    },
    {
      title: 'МОНТАЖ СЭНДВИЧ - ПАНЕЛЕЙ',
      image: '/images/cards/installation/4.png',
    },
    {
      title: 'УСТРОЙСТВО КРОВЛИ',
      image: '/images/cards/installation/5.png',
    },
    {
      title: 'УСТРОЙСТВО ШУМОИЗОЛЯЦИИ',
      image: '/images/cards/installation/6.png',
    },
    {
      title: 'ПРОЕКТНЫЕ И МОНТАЖНЫЕ РАБОТЫ ИНЖЕНЕРНЫХ СИСТЕМ И КОММУНИКАЦИЙ',
      image: '/images/cards/installation/7.png',
    },
  ];

  const installationPriceData = [
    // Общие услуги
    {
      isSection: true,
      name: 'Общие услуги'
    },
    {
      name: 'Выезд специалиста на объект, консультирование, замер, составление документации',
      unit: 'усл',
      price: 3300
    },
    {
      name: 'Выезд специалиста на объект, консультирование, замер, составление документации (свыше 100 км)',
      unit: 'усл', 
      price: 5500
    },

    // Земляные работы
    {
      isSection: true,
      name: 'Земляные работы'
    },
    {
      name: 'Земляные работы. Разработка грунта экскаватором',
      unit: 'м3',
      price: 450
    },
    {
      name: 'Земляные работы. Разработка грунта вручную',
      unit: 'м3',
      price: 1200
    },

    // Фундаментные работы
    {
      isSection: true,
      name: 'Фундаментные работы'
    },
    {
      name: 'Устройство песчаного основания',
      unit: 'м3',
      price: 1500
    },
    {
      name: 'Устройство щебеночного основания',
      unit: 'м3',
      price: 2200
    },
    {
      name: 'Устройство бетонной подготовки',
      unit: 'м2',
      price: 650
    },
    {
      name: 'Устройство гидроизоляции фундамента',
      unit: 'м2',
      price: 450
    },
    {
      name: 'Армирование фундаментной плиты',
      unit: 'т',
      price: 15000
    },
    {
      name: 'Бетонирование фундаментной плиты',
      unit: 'м3',
      price: 3500
    },

    // Монтаж металлоконструкций
    {
      isSection: true,
      name: 'Монтаж металлоконструкций'
    },
    {
      name: 'Монтаж металлических колонн',
      unit: 'т',
      price: 25000
    },
    {
      name: 'Монтаж металлических ферм',
      unit: 'т',
      price: 28000
    },
    {
      name: 'Монтаж связей и распорок',
      unit: 'т',
      price: 22000
    },
    {
      name: 'Монтаж прогонов кровли',
      unit: 'т',
      price: 24000
    },

    // Ограждающие конструкции
    {
      isSection: true,
      name: 'Ограждающие конструкции'
    },
    {
      name: 'Монтаж стеновых сэндвич-панелей',
      unit: 'м2',
      price: 950
    },
    {
      name: 'Монтаж кровельных сэндвич-панелей',
      unit: 'м2',
      price: 1100
    },
    {
      name: 'Монтаж фасонных элементов',
      unit: 'пм',
      price: 350
    },

    // Кровельные работы
    {
      isSection: true,
      name: 'Кровельные работы'
    },
    {
      name: 'Устройство мембранной кровли',
      unit: 'м2',
      price: 850
    },
    {
      name: 'Монтаж водосточной системы',
      unit: 'пм',
      price: 750
    },

    // Полы
    {
      isSection: true,
      name: 'Устройство полов'
    },
    {
      name: 'Устройство бетонных полов',
      unit: 'м2',
      price: 950
    },
    {
      name: 'Шлифовка бетонных полов',
      unit: 'м2',
      price: 350
    },
    {
      name: 'Устройство полимерных полов',
      unit: 'м2',
      price: 1200
    },

    // Проемы
    {
      isSection: true,
      name: 'Заполнение проемов'
    },
    {
      name: 'Монтаж окон ПВХ',
      unit: 'м2',
      price: 4500
    },
    {
      name: 'Монтаж дверей металлических',
      unit: 'шт',
      price: 8500
    },
    {
      name: 'Монтаж ворот секционных',
      unit: 'м2',
      price: 5500
    },

    // Инженерные системы
    {
      isSection: true,
      name: 'Инженерные системы'
    },
    {
      name: 'Монтаж системы отопления',
      unit: 'м2',
      price: 1500
    },
    {
      name: 'Монтаж системы вентиляции',
      unit: 'м2',
      price: 2200
    },
    {
      name: 'Монтаж системы водоснабжения',
      unit: 'пм',
      price: 850
    },
    {
      name: 'Монтаж системы канализации',
      unit: 'пм',
      price: 950
    },

    // Электромонтажные работы
    {
      isSection: true,
      name: 'Электромонтажные работы'
    },
    {
      name: 'Монтаж электропроводки',
      unit: 'пм',
      price: 450
    },
    {
      name: 'Монтаж светильников',
      unit: 'шт',
      price: 750
    },
    {
      name: 'Монтаж пожарной сигнализации',
      unit: 'м2',
      price: 650
    },
    {
      name: 'Монтаж системы видеонаблюдения',
      unit: 'шт',
      price: 4500
    },
    {
      name: 'Устройство молниезащиты',
      unit: 'м2',
      price: 350
    },
    {
      name: 'Монтаж заземления',
      unit: 'точка',
      price: 2500
    },

    // Благоустройство
    {
      isSection: true,
      name: 'Благоустройство территории'
    },
    {
      name: 'Устройство отмостки',
      unit: 'м2',
      price: 1200
    },
    {
      name: 'Благоустройство территории',
      unit: 'м2',
      price: 850
    },
    {
      name: 'Укладка тротуарной плитки',
      unit: 'м2',
      price: 950
    },
    {
      name: 'Установка бордюрного камня',
      unit: 'пм',
      price: 650
    },
    {
      name: 'Озеленение территории',
      unit: 'м2',
      price: 450
    },
    {
      name: 'Монтаж ограждения территории',
      unit: 'пм',
      price: 1500
    },
    {
      name: 'Устройство парковки',
      unit: 'м2',
      price: 2200
    },
    {
      name: 'Разметка парковки',
      unit: 'м2',
      price: 250
    },

    // Дополнительные системы
    {
      isSection: true,
      name: 'Дополнительные системы'
    },
    {
      name: 'Монтаж системы автоматического полива',
      unit: 'м2',
      price: 850
    },
    {
      name: 'Монтаж системы снеготаяния',
      unit: 'м2',
      price: 2500
    },
    {
      name: 'Устройство дренажной системы',
      unit: 'пм',
      price: 1200
    },
    {
      name: 'Монтаж ливневой канализации',
      unit: 'пм',
      price: 1500
    },

    // Отделочные работы
    {
      isSection: true,
      name: 'Отделочные работы'
    },
    {
      name: 'Устройство подпорных стенок',
      unit: 'м3',
      price: 8500
    },
    {
      name: 'Монтаж декоративных элементов фасада',
      unit: 'м2',
      price: 2200
    },
    {
      name: 'Нанесение декоративной штукатурки',
      unit: 'м2',
      price: 950
    },
    {
      name: 'Покраска фасада',
      unit: 'м2',
      price: 450
    },
    {
      name: 'Монтаж вентилируемого фасада',
      unit: 'м2',
      price: 2500
    },
    {
      name: 'Устройство витражей',
      unit: 'м2',
      price: 6500
    },
    {
      name: 'Монтаж рекламных конструкций',
      unit: 'м2',
      price: 3500
    },

    // Дополнительные конструкции
    {
      isSection: true,
      name: 'Дополнительные конструкции'
    },
    {
      name: 'Монтаж навесов',
      unit: 'м2',
      price: 2800
    },
    {
      name: 'Устройство козырьков',
      unit: 'м2',
      price: 3200
    },
    {
      name: 'Монтаж лестниц металлических',
      unit: 'м2',
      price: 4500
    },
    {
      name: 'Монтаж ограждений лестниц',
      unit: 'пм',
      price: 2200
    },
    {
      name: 'Устройство пандусов',
      unit: 'м2',
      price: 3500
    },

    // Внутренняя отделка
    {
      isSection: true,
      name: 'Внутренняя отделка'
    },
    {
      name: 'Монтаж подвесных потолков',
      unit: 'м2',
      price: 850
    },
    {
      name: 'Устройство перегородок',
      unit: 'м2',
      price: 1200
    },
    {
      name: 'Монтаж шумоизоляции',
      unit: 'м2',
      price: 750
    },

    // Пусконаладка
    {
      isSection: true,
      name: 'Пусконаладочные работы'
    },
    {
      name: 'Пусконаладочные работы инженерных систем',
      unit: 'усл',
      price: 45000
    }
  ];

  const items = [
    {
      icon: <PhoneLineIcon />,
      description: t('services.metall.info.phone')
    },
    {
      icon: <FileIcon />,
      description: t('services.metall.info.file')
    },
    {
      icon: <PlaneIcon />,
      description: t('services.metall.info.plane')
    },
  ];

  return (
    <div className="service-page">
      <PageTitle title={t('services.installation.title')} />
      <Banner serviceType={serviceType} Image={'/images/cards/installation/installation.png'} showList={false}/>
      <Cards cards={cards} maxCardHeight={'170px'} maxCardWidth={'340px'} maxCardsWidth={'100%'} maxCardTitleHeight={'85px'}/>
      <InfoGraphickBlock
            title={t('services.installation.infograph_title')}
            subTitle={t('services.installation.infograph_subtitle')}
            image={'/images/instalation_infograph.png'}
        />
      <InstallationPriceTable 
        title={t('services.installation.table.title')}
        subtitle={t('services.installation.table.subtitle')}
        data={installationPriceData} 
        buttonText={t('services.installation.table.buttonText')}
        buttonTitle={t('services.installation.table.buttonTitle')}
      />
      <ServicesDescription items={items} />
      <RequestForm />
    </div>
  );
};

export default Installation; 